import { __awaiter } from "tslib";
import { removeSelector, removeSubscriber } from "../reducers/actions";
import { getSelectors, getSubscribers } from "../reducers/selectors";
import { isStubSelector } from "./requestDefaults";
export function removeSelectorPath(params) {
    return (dispatch_1, getState_1, _a) => __awaiter(this, [dispatch_1, getState_1, _a], void 0, function* (dispatch, getState, {}) {
        var _b;
        const rootState = getState();
        const selectors = getSelectors(rootState);
        dispatch(removeSubscriber(params));
        const subscribers = getSubscribers(getState());
        const selector = selectors.find((s) => s.path === params.path && !isStubSelector(s));
        if (selector != null && ((_b = subscribers[params.path]) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            dispatch(removeSelector(selector));
        }
    });
}
//# sourceMappingURL=removeSelectorPath.js.map